import React, {memo} from 'react';

import iconAlarm from '../../../assets/images/icons/settings/alarm.png';
import iconCam from '../../../assets/images/icons/settings/cam.png';
import iconDatabase from '../../../assets/images/icons/settings/database.png';
import iconDevices from '../../../assets/images/icons/settings/devices.png';
import iconGateways from '../../../assets/images/icons/settings/gateways.png';
import iconIntercom from '../../../assets/images/icons/settings/intercom.png';
import iconLanguage from '../../../assets/images/icons/settings/language.png';
import iconMainPage from '../../../assets/images/icons/settings/main-page.png';
import iconCustomization from '../../../assets/images/icons/settings/customization.png';
import iconProjectInfo from '../../../assets/images/icons/settings/project-info.png';
import iconRemotes from '../../../assets/images/icons/settings/remotes.png';
import iconSensors from '../../../assets/images/icons/settings/sensors.png';
import iconSetup from '../../../assets/images/icons/settings/setup.png';
import iconSip from '../../../assets/images/icons/settings/sip.png';
import iconConcierge from '../../../assets/images/icons/settings/concierge.png';
import iconSound from '../../../assets/images/icons/settings/sound.png';
import iconSystemInfo from '../../../assets/images/icons/settings/system-info.png';
import iconTime from '../../../assets/images/icons/settings/time-mini.png';
import iconUsers from '../../../assets/images/icons/settings/users.png';
import iconWifi from '../../../assets/images/icons/settings/wifi.png';
import iconControls from '../../../assets/images/icons/settings/controls.png';
import iconDoors from '../../../assets/images/icons/settings/doors.png';
import iconInputs from '../../../assets/images/icons/settings/inputs.png';
import iconLocation from '../../../assets/images/icons/settings/location.png';
import iconServers from '../../../assets/images/icons/settings/servers.png';
import iconVirtualControls from '../../../assets/images/icons/settings/virtual-controls.png';
import iconThirdParty from '../../../assets/images/icons/settings/third-party.png';
import iconScreen from '../../../assets/images/icons/digital-platform.png';
import {Page, BaseSettingsScreenBase} from '../BaseSettingsScreen';
import {useDispatch} from "react-redux";
import {backButtonToggle} from "../../../store/ui/actions";

const getPages = (gatewayId: string): Page[] => [
  {
    icon: iconProjectInfo,
    title: "project_information",
    requiredRole: "service",
    routerLink: "/project-information",
  },
  {
    icon: iconGateways,
    title: "gateway",
    requiredRole: "service",
    routerLink: "/gateway",
  },
  {
    icon: iconDevices,
    title: "devices",
    requiredRole: "service",
    routerLink: "/device",
  },
  {
    icon: iconControls,
    title: "controls",
    requiredRole: "service",
    routerLink: "/control",
  },
  {
    icon: iconVirtualControls,
    title: "virtual_controls",
    requiredRole: "service",
    routerLink: "/virtual-control",
  },
  {
    icon: iconInputs,
    title: "inputs",
    requiredRole: "service",
    routerLink: "/input",
  },
  {
    icon: iconControls,
    title: "stp_editor_2",
    requiredRole: "service",
    routerLink: "/stp-editor",
  },
  {
    icon: iconSetup,
    title: "deployment_2",
    requiredRole: "service",
    routerLink: `/gateway/${gatewayId || "1"}/setup/match`,
  },
  {
    icon: iconDoors,
    title: "doors",
    requiredRole: "service",
    routerLink: "/door",
  },
  {
    icon: iconCam,
    title: "cameras",
    requiredRole: "service",
    routerLink: "/camera",
  },
  {
    icon: iconIntercom,
    title: "intercom",
    requiredRole: "service",
    routerLink: "/intercom",
  },
  {
    icon: iconSip,
    title: "sip",
    requiredRole: "service",
    routerLink: `/gateway/${gatewayId || "1"}/sip`,
  },
  {
    icon: iconControls,
    title: "left_menu",
    requiredRole: "service",
    routerLink: "/left-menu",
  },
  {
    icon: iconSensors,
    title: "sensors",
    requiredRole: "admin",
    routerLink: "/sensors",
  },
  {
    icon: iconRemotes,
    title: "remotes",
    requiredRole: "admin",
    routerLink: "/media",
  },
  {
    icon: iconLocation,
    title: "location",
    requiredRole: "admin",
    routerLink: "/time",
  },
  {
    icon: iconWifi,
    title: "wifi",
    requiredRole: "admin",
    routerLink: `/gateway/${gatewayId || "1"}/wifi`,
  },
  {
    icon: iconAlarm,
    title: "alarm",
    requiredRole: "admin",
    routerLink: "/alarm",
  },
  {
    icon: iconUsers,
    title: "users",
    requiredRole: "user",
    routerLink: "/users",
  },
  {
    icon: iconLanguage,
    title: "language",
    requiredRole: "admin",
    routerLink: "/language",
  },
  {
    icon: iconCustomization,
    title: "customization",
    requiredRole: "default",
    routerLink: "/custom-menu",
  },
  {
    icon: iconMainPage,
    title: "home_page_2",
    requiredRole: "admin",
    routerLink: "/homepage",
  },
  {
    icon: iconTime,
    title: "date_time",
    requiredRole: "user",
    routerLink: "/set-date-time",
  },
  {
    icon: iconSound,
    title: "sounds",
    requiredRole: "default",
    routerLink: "/sound",
  },
  {
    icon: iconSystemInfo,
    title: "system_information",
    requiredRole: "service",
    routerLink: "/system-info",
  },
  {
    icon: iconControls,
    title: "gateway_control",
    requiredRole: "admin",
    routerLink: `/gateway-control/${gatewayId || "1"}`,
  },
  {
    icon: iconConcierge,
    title: "concierge",
    requiredRole: "service",
    routerLink: "/concierge",
  },
  {
    icon: iconServers,
    title: "server",
    requiredRole: "service",
    routerLink: "/server",
  },
  {
    icon: iconDatabase,
    title: "database",
    requiredRole: "service",
    routerLink: "/db",
  },
  {
    icon: iconThirdParty,
    title: "IF DO",
    requiredRole: "admin",
    routerLink: "/third-party",
  },
];

export const UserSettingsScreen = memo(function UserSettingsScreen() {
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    return (
        <BaseSettingsScreenBase
            baseRoute={'/settings'}
            getPages={getPages}/>
    );
});
